import { combineReducers } from 'redux-immutable';
import { Reducer } from 'redux';
import global from './global';
import prefill from './prefill';
import planBuilder from './plan-builder';
import modeler from './modeler';
import businessDetails from './business-details';
import source from './source';
import user from './user';
import thimble from './thimble';
import thimbleFlow from './thimbleFlow/reducer';
import quotes from './quotes';
import coterie from './coterie/reducer';
import jobSearch from './job-search';
import exclusion from './exclusion';

const rootReducer: Reducer = combineReducers({
  global,
  prefill,
  thimble,
  thimbleFlow,
  planBuilder,
  modeler,
  businessDetails,
  source,
  user,
  quotes,
  coterie,
  jobSearch,
  exclusion,
});

export default rootReducer;
